import type { RoomState } from '../shared/types.js';
import type { LocalGame } from './local-game.js';
import { loadLocalGame, saveLocalGame } from './local-game.js';

export type ClientState = {
  myPlayerId: string | null;
  room: RoomState | null;
  connected: boolean;
  lastError: { code: string; msg: string; ts: number } | null;
  name: string;
  local: LocalGame | null;
};

type Listener = (s: ClientState) => void;

const NAME_KEY = 'dice-name';

export class Store {
  private state: ClientState;
  private listeners = new Set<Listener>();

  constructor() {
    this.state = {
      myPlayerId: null,
      room: null,
      connected: false,
      lastError: null,
      name: localStorage.getItem(NAME_KEY) ?? '',
      local: loadLocalGame(),
    };
  }

  get(): ClientState { return this.state; }

  update(mut: (s: ClientState) => void): void {
    mut(this.state);
    if (this.state.name) localStorage.setItem(NAME_KEY, this.state.name);
    saveLocalGame(this.state.local);
    for (const l of this.listeners) l(this.state);
  }

  subscribe(l: Listener): () => void {
    this.listeners.add(l);
    l(this.state);
    return () => this.listeners.delete(l);
  }
}
